import React from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { TablePaginationConfigProps } from '../../table/table';
import { AutoCompleteProps } from '../../auto-complete/auto-complete';
import { DragAndDropProps } from '../../drag-and-drop/drag-and-drop';

export const DefaultPaginationProps: TablePaginationConfigProps = {
	pageSize: 5,
	hideOnSinglePage: true
};

export const DefaultAutoCompleteProps: Partial<AutoCompleteProps> = {
	allowClear: true
};

export const DefaultDragAndDropProps: Partial<DragAndDropProps> = {
	accept: '.csv',
	showUploadList: false,
	text: 'Click or drag in order to upload file',
	icon: <BringgIcon iconName={BringgFontIcons.CsvFile} style={{ fontSize: '50px' }} />
};
